import React from 'react'

const PinIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="pinGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 100, 120, 1)" />
          <stop offset="100%" stopColor="rgba(220, 60, 100, 1)" />
        </linearGradient>
        <filter id="pinGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Pin head */}
      <circle 
        cx="12" 
        cy="7" 
        r="4" 
        fill="url(#pinGradient)"
        filter="url(#pinGlow)"
      />
      
      {/* Pin needle */}
      <path 
        d="M12 11 L12 20"
        stroke="url(#pinGradient)"
        strokeWidth="2"
        strokeLinecap="round"
        filter="url(#pinGlow)"
      />
      
      {/* Highlight on pin head */}
      <circle 
        cx="11" 
        cy="6" 
        r="1.5" 
        fill="rgba(255, 255, 255, 0.5)"
      />
    </svg>
  )
}

export default PinIcon
